import { IMemberProps } from 'common/interface/props';
import Grid from 'components/UI/atoms/Grid';
import ShopLoginForm from 'components/UI/organisms/ShopLoginForm';
import Container from 'components/UI/atoms/Container';
import Banner from 'components/UI/molecules/Banner';

export default function ShopLogin({ solType }: IMemberProps) {
  return (
    <>
      <Banner imgPath="/images/bg_title4.png" text="사이트 선택" />

      <Container>
        <Grid bottom={60}>
          <ShopLoginForm solType={solType} />
        </Grid>
      </Container>
    </>
  );
}
